import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaArrowDown,
  FaArrowUp,
  FaBolt,
  FaChevronRight,
  FaCoins,
  FaCrown,
  FaMoneyBillWave,
  FaWallet,
} from "react-icons/fa";

const WalletPage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("transactions");

  const walletInfo = {
    totalBalance: "₹24,680",
    available: "₹22,180",
    winnings: "₹12,450",
    bonus: "₹500",
  };

  const transactions = [
    {
      id: 1,
      type: "deposit",
      amount: "₹5,000",
      status: "success",
      date: "2 hours ago",
      method: "UPI",
    },
    {
      id: 2,
      type: "withdrawal",
      amount: "₹2,000",
      status: "pending",
      date: "5 hours ago",
      method: "Bank Transfer",
    },
    {
      id: 3,
      type: "deposit",
      amount: "₹1,000",
      status: "success",
      date: "Yesterday",
      method: "Card",
    },
  ];

  const bettingTransactions = [
    {
      id: 1,
      match: "CSK vs MI",
      amount: "₹500",
      result: "won",
      profit: "+₹950",
      date: "2 hours ago",
    },
    {
      id: 2,
      match: "RCB vs GT",
      amount: "₹200",
      result: "lost",
      profit: "-₹200",
      date: "5 hours ago",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-900 pb-20">
      {/* Top Balance Card */}
      <div className="bg-gradient-to-b from-blue-900/50 via-gray-900 to-gray-900 pt-6 pb-8">
        <div className="max-w-lg mx-auto px-4">
          <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700/50 rounded-xl p-6 relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-green-500/10 animate-pulse" />
            <h2 className="text-gray-400 mb-2">Total Balance</h2>
            <div className="text-3xl font-bold text-white mb-4 flex items-baseline">
              {walletInfo.totalBalance}
              <span className="text-green-400 text-sm ml-2">+2.5%</span>
            </div>

            <div className="grid grid-cols-3 gap-4">
              <BalanceCard
                icon={FaWallet}
                label="Available"
                value={walletInfo.available}
              />
              <BalanceCard
                icon={FaCoins}
                label="Winnings"
                value={walletInfo.winnings}
              />
              <BalanceCard
                icon={FaCrown}
                label="Bonus"
                value={walletInfo.bonus}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="max-w-lg mx-auto px-4 -mt-4">
        <div className="grid grid-cols-2 gap-4">
          <button
            onClick={() => navigate("/deposit")}
            className="bg-gradient-to-r from-green-600 to-green-500 text-white py-4 px-6 rounded-xl font-medium hover:from-green-500 hover:to-green-400 transition-all flex items-center justify-center gap-2 shadow-lg shadow-green-900/20"
          >
            <FaArrowDown className="text-green-200" />
            Deposit
          </button>
          <button
            onClick={() => navigate("/withdraw")}
            className="bg-gradient-to-r from-blue-600 to-blue-500 text-white py-4 px-6 rounded-xl font-medium hover:from-blue-500 hover:to-blue-400 transition-all flex items-center justify-center gap-2 shadow-lg shadow-blue-900/20"
          >
            <FaArrowUp className="text-blue-200" />
            Withdraw
          </button>
        </div>

        {/* Transactions Section */}
        <div className="mt-8">
          <div className="flex border-b border-gray-800">
            {["transactions", "betting"].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`py-3 px-6 relative ${
                  activeTab === tab
                    ? "text-blue-500"
                    : "text-gray-400 hover:text-gray-300"
                }`}
              >
                {tab === "transactions" ? "Transactions" : "Betting History"}
                {activeTab === tab && (
                  <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-500" />
                )}
              </button>
            ))}
          </div>

          <div className="py-4 space-y-4">
            {activeTab === "transactions"
              ? transactions.map((tx) => (
                  <TransactionCard key={tx.id} transaction={tx} />
                ))
              : bettingTransactions.map((bet) => (
                  <BettingTransactionCard key={bet.id} transaction={bet} />
                ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const BalanceCard = ({ icon: Icon, label, value }) => (
  <div className="bg-gray-800/30 backdrop-blur-sm rounded-lg p-3 hover:bg-gray-800/50 transition-all group cursor-pointer">
    <Icon className="w-5 h-5 text-gray-400 group-hover:text-blue-400 transition-colors" />
    <div className="text-xs text-gray-400 mt-1">{label}</div>
    <div className="text-white font-semibold mt-0.5">{value}</div>
  </div>
);

const TransactionCard = ({ transaction }) => (
  <div className="bg-gray-800/30 rounded-lg p-4 hover:bg-gray-800/50 transition-all">
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        <div
          className={`p-2 rounded-lg ${
            transaction.type === "deposit"
              ? "bg-green-500/20 text-green-400"
              : "bg-blue-500/20 text-blue-400"
          }`}
        >
          {transaction.type === "deposit" ? <FaArrowDown /> : <FaArrowUp />}
        </div>
        <div>
          <div className="text-white font-medium capitalize">
            {transaction.type}
          </div>
          <div className="text-gray-400 text-sm">Via {transaction.method}</div>
        </div>
      </div>
      <div className="text-right">
        <div className="text-white font-medium">{transaction.amount}</div>
        <div className="text-xs text-gray-400">{transaction.date}</div>
      </div>
    </div>
    <div
      className={`text-xs mt-2 ${
        transaction.status === "success"
          ? "text-green-400"
          : transaction.status === "pending"
          ? "text-yellow-400"
          : "text-red-400"
      }`}
    >
      {transaction.status.toUpperCase()}
    </div>
  </div>
);

const BettingTransactionCard = ({ transaction }) => (
  <div className="bg-gray-800/30 rounded-lg p-4 hover:bg-gray-800/50 transition-all">
    <div className="flex justify-between items-center">
      <div>
        <div className="text-white font-medium">{transaction.match}</div>
        <div className="text-sm text-gray-400">
          Bet Amount: {transaction.amount}
        </div>
      </div>
      <div className="text-right">
        <div
          className={
            transaction.result === "won" ? "text-green-400" : "text-red-400"
          }
        >
          {transaction.profit}
        </div>
        <div className="text-xs text-gray-400">{transaction.date}</div>
      </div>
    </div>
  </div>
);

export default WalletPage;
